module.exports = __webpack_public_path__ + "static/img/bg27.b90aef7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg27.jpg
// module id = MPYP
// module chunks = 1